import React, { Component } from "react";
import { connect } from "react-redux";

import { EditableCellContent } from "./editableCellContent";
import { ReadOnlyCellContent } from "./readOnlyCellContent";
import { formatValueFromMapping } from "../../../utils/misc";


class _EditableCellWrapper extends Component {

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        // this component receives a number of props that will update on occasion, but that don't
        // don't affect this specific cell. Because we don't want to re-render unnecessarily we
        // will check the nested values of those props that are specific to this cell and only
        // force an update if those have changed.
        // We can ignore checking most the props here because they are meant to be immutable.
        // We ignore cellData because this is an uncontrolled input therefore we don't want to
        // re-render just to show the updated value, as the cell will already be showing it.

        const { rowKey, field, fieldErrors, isDeleted } = this.props;
        const { fieldErrors: newFieldErrors, isDeleted: newIsDeleted } = nextProps;

        let needToUpdate = false;

        const cellError = this.getCellError(fieldErrors, rowKey, field);
        const newCellError = this.getCellError(newFieldErrors, rowKey, field);

        if ( cellError !== newCellError ) {
            needToUpdate = true;
        }

        if (isDeleted !== newIsDeleted) {
            needToUpdate = true;
        }

        return needToUpdate
    }

    getCellData(rows, rowKey, field) {
        const rowData = rows[rowKey];
        let cellData = undefined;
        if ( rowData !== undefined ) {
            cellData = rowData[field.name]
        }
        return cellData
    }

    getAddedCellData(addedRows, rowKey, field) {
        const addedRowData = addedRows[rowKey];
        let addedCellData = undefined;
        if ( addedRowData !== undefined ) {
            addedCellData = addedRowData[field.name]
        }
        return addedCellData
    }

    getCellError(fieldErrors, rowKey, field) {
        const rowErrors = fieldErrors[rowKey];
        let cellError = undefined;
        if ( rowErrors !== undefined ) {
            cellError = rowErrors[field.name];
        }
        return cellError
    }

    isAddedRow() {
        const { rowKey, addedRows } = this.props;
        return Object.keys(addedRows).includes(rowKey)
    }

    render() {

        const { rows, addedRows, editableFields, field, fieldTypes, fieldChoices, rowKey,
            isDeleted, valueMapping, fieldErrors, inputProperties } = this.props;

        const cellData = this.isAddedRow() ?
            this.getAddedCellData(addedRows, rowKey, field) :
            this.getCellData(rows, rowKey, field);

        let className = isDeleted ? "register-table--cell__deleted" : "";

        // update class if this field has an error
        const cellError = this.getCellError(fieldErrors, rowKey, field)
        if ( cellError !== undefined ) {
            className += " register-table--cell__error"
        }

        // we're in an editable row, but we may not actually be editable in this cell. let's check.
        let isEditable = false;
        if ( this.isAddedRow() ) {
            isEditable = true;  // all cells in an added row are editable.
        } else if ( editableFields.includes(field.name) ) {
            isEditable = true;
        }

        return (
            <td className={ "register-table--editable-cell " + className }>
                { isEditable ?
                    <EditableCellContent
                        cellData={ cellData }
                        field={ field }
                        fieldType={ fieldTypes[field.name] }
                        fieldChoices={ fieldChoices[field.name] }
                        inputProperties={ inputProperties[field.name] || {} }  // don't want it to break if there's no values
                        rowKey={ rowKey }
                        isDeleted={ isDeleted }
                    />
                    :
                    <ReadOnlyCellContent
                        cellData={ formatValueFromMapping(cellData, field.name, valueMapping) }
                        fieldType={ fieldTypes[field.name] }
                        extraClassNames={`register-table--read-only-cell u-muted`}
                    />
                }
            </td>
        )
    }
}

export const EditableCellWrapper = connect((state) => ({
    rows: state.mutableBaseData.rows,
    addedRows: state.mutableEditing.addedRows,
    fieldErrors: state.mutableEditing.fieldErrors,
    fieldTypes: state.immutableBaseData.fieldTypes,
    valueMapping: state.immutableBaseData.valueFormatterMapping,
    editableFields: state.immutableEditing.fields,
    fieldChoices: state.immutableEditing.options,
    inputProperties: state.immutableEditing.inputProperties,
}))(_EditableCellWrapper);
